<script context="module">
  import LoadingPopup from "./LoadingPopup.svelte";

  import { External } from '../external';

  export function showLoadingPopup(then) {
    External.Tools.showWindow({
      isModal: true,
      width: 400,
      noNav: true,
      noTitle: true,
      forceAtRight: false,
      action: {
        onShow: async (popup, ui) => {
          popup.bindComponent(
            new LoadingPopup({
              target: popup.getContentArea(),
              props: {}
            })
          );
          then(popup);
        }
      }
    });
  }
</script>
<script>

  import Loader from './Loader.svelte';
</script>

<div class="col20 f-left" style="height: 200px">
  <Loader />
</div>
